import { FilterNodeConditionType } from "@/models/search/filter-node-condition/FilterNodeCondition";
import { ValidationResult } from "@/models/search/ValidationResult";
import { filterInputCheck } from "@/models/search/filter-node-condition/FilterNodeCondition";
import { i18n } from "@/i18n";

/**
 * 行動履歴による条件
 *
 * 絞り込み条件に追加で、訪問のとき、訪問担当者（部分一致）を条件として付与できる
 */
export class FilterContactEmployeeCondition {
  public readonly conditionType = FilterNodeConditionType.ContactEmployee;
  constructor(public readonly employee: string) {}

  get validate(): ValidationResult {
    return filterInputCheck(
      this.employee,
      i18n.t("models.contactAttribute.personInCharge") as string
    );
  }
}
